import { EventRegister } from 'react-native-event-listeners';

export enum OpportunityEvents {
  REFRESH = 'REFRESH',
}

export const refreshOpportunityList = () => {
  EventRegister.emit(OpportunityEvents.REFRESH);
};
